export const SHELL_BREAKPOINTS = {
  compact: 1180,
};

export const VIEW_BREAKPOINTS = {
  reservationsWeekGridMin: 1320,
  announcementsTableMin: 1100,
};

export const PHONE_BREAKPOINT = 768;